import { motion } from "framer-motion";
import { scrollToId } from "../../lib/scroll";
import { useSection } from "../../lib/content";
import { trackCta } from "../../lib/track";
import { EASE } from "./Reveal";

export const Hero = () => {
  const c = useSection("hero");

  return (
    <section id="hero" className="relative bg-white pt-[72px]">
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1, delay: 0.2, ease: EASE }}
        className="relative"
      >
        <img
          data-testid="hero-banner-image"
          src={c.image}
          alt="Move from HP Poly Gen 1 to Gen 2 — Prepare Your Meeting Rooms for What's Next. Build a more capable, responsive and future-ready collaboration environment, powered by HP Poly VideoOS 5.0."
          className="w-full h-auto block"
        />
        {/* White patch covers the two buttons baked into the banner artwork */}
        <div
          className="absolute z-10 bg-white"
          style={{ left: "0%", top: "58.5%", width: "46%", height: "14.5%" }}
        />
        <button
          data-testid="hero-cta-plan-button"
          onClick={() => { trackCta("hero"); scrollToId("contact"); }}
          className="absolute z-20 hidden lg:flex items-center justify-center bg-black text-white font-semibold rounded-md cursor-pointer hover:bg-[#024AD8] active:scale-[0.98] transition-colors duration-300"
          style={{
            left: "1.5%",
            top: "61.5%",
            height: "9%",
            paddingInline: "clamp(16px, 2vw, 40px)",
            fontSize: "clamp(12px, 1vw, 18px)",
          }}
        >
          Connect with your HP Poly specialist
        </button>
      </motion.div>

      <div className="lg:hidden px-6 py-6 bg-white">
        <button
          data-testid="hero-cta-plan-button-mobile"
          onClick={() => { trackCta("hero-mobile"); scrollToId("contact"); }}
          className="w-full bg-[#024AD8] text-white text-sm font-semibold px-5 py-3.5 rounded-md active:scale-[0.98] transition-transform"
        >
          Connect with your HP Poly specialist
        </button>
      </div>
    </section>
  );
};
